import { column } from "@podtrac/common/grid";

export const typeColumn = () =>
    column.group({
        header: "Type",
        columns: [
            column.accessor("promotionType", {
                id: "Type",
                header: "",
            }),
        ],
    });
